import { render, staticRenderFns } from "./CorrectionApplyModal.vue?vue&type=template&id=2076fb45&scoped=true"
import script from "./CorrectionApplyModal.vue?vue&type=script&lang=js"
export * from "./CorrectionApplyModal.vue?vue&type=script&lang=js"
import style0 from "./CorrectionApplyModal.vue?vue&type=style&index=0&id=2076fb45&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2076fb45",
  null
  
)

export default component.exports